module.exports = __webpack_public_path__ + "static/img/3.217a23d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/sp/3.png
// module id = XxVE
// module chunks = 0